/**
 * Central fetch wrapper for Stallflow web.
 * All API calls MUST go through here - never hardcode /api/... in components.
 * Base is "/" (vite base path) + /api prefix handled by dev proxy.
 */
export class AppError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "AppError";
    }
}
// Vite injects `import.meta.env.BASE_URL` from the `base` config (e.g. "/").
// Strip the trailing slash so we can append `/api/...` without doubling up.
const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");
async function apiFetch(path, init) {
    const apiPath = path.startsWith("/api") ? path : `/api${path}`;
    const url = `${BASE}${apiPath}`;
    const res = await fetch(url, {
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            ...init?.headers,
        },
        ...init,
    });
    if (!res.ok) {
        let message = `Request failed: ${res.status}`;
        try {
            const body = await res.json();
            if (typeof body?.message === "string")
                message = body.message;
        }
        catch {
            // ignore
        }
        throw new AppError(res.status, message);
    }
    return res.json();
}
export const api = {
    get: (path, init) => apiFetch(path, { method: "GET", ...init }),
    post: (path, body, init) => apiFetch(path, {
        method: "POST",
        body: JSON.stringify(body),
        ...init,
    }),
    patch: (path, body, init) => apiFetch(path, {
        method: "PATCH",
        body: JSON.stringify(body),
        ...init,
    }),
    delete: (path, init) => apiFetch(path, { method: "DELETE", ...init }),
};
